import React from 'react';

import ChevronDownIcon from '@atlaskit/icon/core/chevron-down';
import { fg } from '@atlaskit/platform-feature-flags/fg';

import { PanelAction } from '../../panel-action/panel-action';
import type { PanelActionProps } from '../../panel-action/types';

export interface PanelActionDownProps extends Pick<
	PanelActionProps,
	'onClick' | 'testId' | 'label'
> {}

/**
 * A navigation action for moving down in panels. Place PanelActionUp followed by
 * PanelActionDown before other actions in PanelActionGroup.
 */
export const PanelActionDown: React.ForwardRefExoticComponent<
	PanelActionDownProps & React.RefAttributes<HTMLButtonElement>
> = React.forwardRef<HTMLButtonElement, PanelActionDownProps>(({ onClick, testId, label }, ref) => {
	if (!fg('platform-dst-panel-system-up-down')) {
		return null;
	}

	return (
		<PanelAction
			ref={ref}
			onClick={onClick}
			testId={testId}
			spacing="compact"
			icon={() => <ChevronDownIcon label="" color="currentColor" size="medium" />}
			label={label || 'Go down'}
		/>
	);
});

PanelActionDown.displayName = 'PanelActionDown';
